import { Check } from "lucide-react";

const ACTION_LABELS = {
  view: "Voir", create: "Créer", edit: "Modifier", delete: "Supprimer",
  export: "Exporter", print: "Imprimer", validate: "Valider",
};

function Cell({ checked, onToggle, testid }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      data-testid={testid}
      className="w-6 h-6 rounded flex items-center justify-center transition-colors mx-auto"
      style={{
        background: checked ? "var(--tm-gold)" : "var(--tm-surface-2)",
        border: `1px solid ${checked ? "var(--tm-gold)" : "var(--tm-border)"}`,
      }}
    >
      {checked && <Check size={14} className="text-black" strokeWidth={3} />}
    </button>
  );
}

// value = { permissions: {section:{action:bool}}, specials: {key:bool} }
export default function PermissionEditor({ schema, value, onChange, disabled }) {
  if (!schema) return null;
  const perms = value.permissions || {};
  const specials = value.specials || {};

  const toggle = (sec, act) => {
    if (disabled) return;
    const next = { ...perms, [sec]: { ...(perms[sec] || {}), [act]: !perms[sec]?.[act] } };
    onChange({ permissions: next, specials });
  };
  const toggleRow = (sec) => {
    if (disabled) return;
    const allOn = schema.actions.every((a) => perms[sec]?.[a]);
    const row = {};
    schema.actions.forEach((a) => { row[a] = !allOn; });
    onChange({ permissions: { ...perms, [sec]: row }, specials });
  };
  const toggleSpec = (key) => {
    if (disabled) return;
    onChange({ permissions: perms, specials: { ...specials, [key]: !specials[key] } });
  };

  return (
    <div className={disabled ? "opacity-50 pointer-events-none" : ""}>
      <p className="text-xs uppercase tracking-wider text-[var(--tm-muted)] mb-2">Permissions par rubrique</p>
      <div className="tm-card overflow-x-auto mb-4" style={{ background: "var(--tm-bg)" }}>
        <table className="tm-table text-xs">
          <thead>
            <tr>
              <th>Rubrique</th>
              {schema.actions.map((a) => <th key={a} className="text-center">{ACTION_LABELS[a] || a}</th>)}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {schema.sections.map((s) => (
              <tr key={s.key}>
                <td className="font-semibold whitespace-nowrap">{s.label}</td>
                {schema.actions.map((a) => (
                  <td key={a} className="text-center">
                    <Cell checked={!!perms[s.key]?.[a]} onToggle={() => toggle(s.key, a)} testid={`perm-${s.key}-${a}`} />
                  </td>
                ))}
                <td className="text-right">
                  <button type="button" onClick={() => toggleRow(s.key)} className="text-[10px] text-[var(--tm-gold)] hover:underline whitespace-nowrap">Tout</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="text-xs uppercase tracking-wider text-[var(--tm-muted)] mb-2">Permissions spécifiques</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {schema.specials.map((sp) => (
          <label key={sp.key} className="flex items-center gap-2 cursor-pointer text-sm py-1">
            <Cell checked={!!specials[sp.key]} onToggle={() => toggleSpec(sp.key)} testid={`spec-${sp.key}`} />
            <span>{sp.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
